import { BaseComponent } from "../BaseComponent";
import { ComponentNames } from 'src/app/helper/componentNames';


export class PodestComponent extends BaseComponent {
    constructor() {
        super();
        this.componentType = ComponentNames.podestComponent;
    }
    height: number;
}